import {IMenuItem} from '../components/layout/header/types';

export const cardsFirstNumbers: any = {
  VISA: '4242',
  MASTERCARD: '5555',
  'AMERICAN EXPRESS': '3782',
  DISCOVER: '6011',
  DINERSCLUB: '3056',
  JCB: '3566',
  UNIONPAY: '6200',
  'DINERS CLUB': '3056',
};

export const productList = [
  {count: 1, color: 'yellow'},
  {count: 5, color: 'green', popular: true},
  {count: 10, color: 'blue', stack: true},
];
export const productInfo = [
  'Number of checks',
];
export const options = [3, 7, 11, 15];

export const menuItemsList: IMenuItem[] = [
  // {
  //   name: 'Why Hexospark',
  //   linkTo: '/why-hexospark',
  //   className: 'nav-link',
  // },
  // {name: 'Pricing', linkTo: '/pricing', className: 'nav-link'},
  {
    name: 'FAQ',
    linkTo: '/faq',
    className: 'nav-link',
  },
  {
    name: 'Academy',
    linkTo: 'https://hexofy.com/academy/',
    className: 'nav-link',
    subMenu: [
      // {
      //   name: 'Insider Guides',
      //   linkTo: 'https://hexospark.com/academy/category/insider-guides/',
      //   className: 'nav-link',
      // },
      {
        name: 'News',
        linkTo: 'https://hexofy.com/academy/category/news/',
        className: 'nav-link',
      },
      {
        name: 'Tutorials',
        linkTo: 'https://hexofy.com/academy/hexofy-tutorials/',
        className: 'nav-link',
      },
    ],
  },
];

export const VALID_PASSWORD_RE =
  /^.*(?=.{8,})((?=.*[!@#$%^&*()\-_=+{};:,<.>]){1})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/;
